import { render, staticRenderFns } from "./profileChangePassword.vue?vue&type=template&id=6b440737&"
import script from "./profileChangePassword.vue?vue&type=script&lang=js&"
export * from "./profileChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports